const getMediaQuery = (width: number) => `@media (max-width:${width}px)`;
export default {
  xs: getMediaQuery(599),
  sm: getMediaQuery(1090),
  md: getMediaQuery(1440),
  lg: getMediaQuery(1920)
}